import React from 'react';

import WorksheetStepStatusIcon from 'notebook/worksheets/steps/WorksheetStepStatusIcon';
import {
  NO_USER,
  StatusTypeToDisplayNameMapping,
  WorksheetTaskStatusType,
} from 'notebook/worksheets/WorksheetConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import Avatar, {HasAvatar} from 'ui-library/avatar/Avatar';
import {AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {formalTimeUTC} from 'util/DateUtil';

interface WorksheetPrinterFriendlyStepHeaderProps {
  status?: WorksheetTaskStatusType;
  name?: string;
  lastEditedUser?: HasAvatar;
  timestamp?: string;
}

export default function WorksheetPrinterFriendlyStepHeader({
  name,
  status = WorksheetTaskStatusType.NOT_READY,
  lastEditedUser,
  timestamp,
}: WorksheetPrinterFriendlyStepHeaderProps): JSX.Element {
  const isStepFinalized =
    status === WorksheetTaskStatusType.COMPLETED ||
    status === WorksheetTaskStatusType.FAILED ||
    status === WorksheetTaskStatusType.SKIPPED;

  return (
    <div className="section step-header">
      <div className="valign">
        <p {...getTestProps({component: 'WorksheetPrinterFriendlyStepHeader', element: 'name'})}>{name}</p>
      </div>
      <div className="valign">
        <div className="inline-flex-center">
          {isStepFinalized && (
            <>
              <span className="margin-left-0_5em timestamp">{formalTimeUTC(timestamp)}</span>
              <div className="margin-left-0_5em inline-flex-center">
                <Avatar entity={lastEditedUser ?? NO_USER} size={AvatarSize.XXSMALL} />
              </div>
              <span className="margin-left-0_5em margin-right-15px">{lastEditedUser?.name}</span>
            </>
          )}
          <WorksheetStepStatusIcon viewer={true} status={status} />
          <span className="margin-left-0_5em">
            {/* This is a workaround because if a step belongs to a "Run" group and the "Pre-run" steps are
            not yet completed, the status of the step depends on whether the unit operation is "PENDING" or not.
            We want the status of a step to be displayed as "NOT READY" if the step belongs to a "Run" group
            and the "Pre-run" steps are not yet completed, regardless of the unit operation status.
            */}
            {StatusTypeToDisplayNameMapping[status]}
          </span>
        </div>
      </div>
    </div>
  );
}
